import CardCommon from '@op/components/CardCommon';
import React from 'react';
import { Button, Icon } from 'tea-component';
import { useIntl } from 'umi';
import { UrlPercentType, useUrlState } from '../../../hook';
import BubbleCommon, {
  keywordDrillUrlFailedTips,
} from '@op/components/BubbleCommon';
import { GPTContentType } from '../../../types';
import useReportCreateSuccess from '../../../../hooks/useReportCreateSuccess';

export default function UrlLoadingCard({
  children,
  handleStop,
  saveTipsElement,
  setLoading,
  taskId,
  filter,
  isPreviews,
  gameInfo,
  taskData,
  gptList,
  setAllCommentsFilter,
  setShowCheckbox
}: {
  children: (props: {
    isSingleUrl: boolean;
    gptTaskList: any;
    percentList: Array<UrlPercentType>;
  }) => any;
  filter: any;
  taskId?: number;
  setLoading: (flag: boolean) => void;
  handleStop: () => void;
  isPreviews?: boolean;
  saveTipsElement: any;
  gameInfo: any;
  taskData?: any;
  gptList: { current: GPTContentType[]; };
  setAllCommentsFilter: (filter: any) => void;
  setShowCheckbox: (show: boolean) => void;
}) {
  const {
    loading: urlLoading,
    percent,
    isSingleUrl,
    percentList,
    stop,
    gptTaskList,
    isError,
  } = useUrlState({
    filter,
    taskId,
    setFilterLoading: setLoading,
    isPreviews,
    gameInfo,
    taskData,
    gptList,
    setAllCommentsFilter,
    setShowCheckbox
  });
  const { formatMessage } = useIntl();

  // URL 爬取进度卡片出现时自动滚动（预览模式不滚动）
  const { reportRef: urlLoadingRef } = useReportCreateSuccess({
    trigger: urlLoading && !isPreviews,
    delay: 300,
    maxRetries: 8,
  });

  function getPercentText({ status, count }: UrlPercentType) {
    if (status === 'loading') {
      return formatMessage(
        {
          id:
            count <= 1
              ? '{count} comment have been crawled.'
              : '{count} comments have been crawled.',
        },
        { count: <span style={{ color: '#29B569' }}>{count}</span> },
      );
    }

    if (status === 'error') {
      return (
        <BubbleCommon showIcon={false} tipsMap={keywordDrillUrlFailedTips}>
          {formatMessage({ id: 'Scraping failed' })}
        </BubbleCommon>
      );
    }

    return formatMessage(
      {
        id:
          count <= 1
            ? 'Completed (Crawled {count} comment)'
            : 'Completed (Crawled {count} comments)',
      },
      { count: <span style={{ color: '#29B569' }}>{count}</span> },
    );
  }

  return urlLoading ? (
    <div ref={urlLoadingRef} className="dbo-url-card dbo-aigc-card-wrapper">
      <CardCommon
        loading={percentList.length === 0}
        loadingHeight={200}
        contentCard
        className="gpt-summary"
      >
        <div className="dbo-url-card-operate  dbo-url-card-operate-single">
          <div className="dbo-url-card-operate-loading">
            {/* <Icon type="loading" /> */}
            {formatMessage({ id: 'In data scraping' })}{' '}
            <span className="dbo-url-card-operate-loading-tips">
              ({formatMessage({ id: 'it requires 0.5~1 hours to complete.' })})
            </span>
          </div>
          <div className="dbo-url-card-operate-save">{saveTipsElement}</div>
          <ul className="dbo-url-status">
            {percentList.map(({ status, url, count }, index: number) => {
              return (
                <li key={url}>
                  <Icon type={status} />
                  <span className="dbo-url-status-title">URL{index + 1}</span>
                  <span className="dbo-url-status-result">
                    {getPercentText({ status, url, count })}
                  </span>
                </li>
              );
            })}
          </ul>
          <Button
            type="weak"
            className="dbo-btn-stop"
            onClick={() => {
              stop();
              handleStop();
            }}
          >
            {formatMessage({ id: 'Stop' })}
          </Button>
        </div>
      </CardCommon>
    </div>
  ) : (
    children({ gptTaskList, isSingleUrl, percentList })
  );
}
